export class VersionNumber {
    public major: number;
    public minor: number;
    public patch: number;

    public versionRegex = /^(\d+)\.(\d+)\.(\d+)$/g;

    constructor(
        private version: string
    ) {
        if (!this.version.length) {
            this.major = 0;
            this.minor = 0;
            this.patch = 0;

            return;
        }

        if (!this.versionRegex.test(this.version)) {
            throw Error(`Invalid version "${this.version}"`);
        }

        let parts = this.version.split('.');
        this.major = parseInt(parts[0], 10);
        this.minor = parseInt(parts[1], 10);
        this.patch = parseInt(parts[2], 10);
    }
}
